export default function TensorIcon() {
  return (
    <svg
      viewBox="0 0 1263 1280"
      xmlns="http://www.w3.org/2000/svg"
      width="26px"
      height="26px"
    >
      <path
        d="M552.5 144 55 643h217.5L409 506.5V992l143.5 143.5V144ZM712 144l497.5 499H992L855.5 506.5V992L712 1135.5V144Z"
        fill="white"
      ></path>
    </svg>
  )
}
